import { useEffect, useState } from "react";

/** The stats of a monitor tab, fetched again whenever `reloadKey` changes. A failed load leaves them empty. */
export default function useStats(fetchStats, reloadKey) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    setLoading(true);
    fetchStats({})
      .then((res) => active && setStats(res.data?.data ?? null))
      .catch(() => active && setStats(null))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [fetchStats, reloadKey]);
  return { stats, loading };
}
